import { http, onSuccess, onFail } from "./http";

export const questionsUpdate = (eventPassword, params) =>
    http.put(`/api/cp/event/${eventPassword}/question/messages`, params)
        .then(onSuccess, onFail);

export const questionsDelete = (eventPassword, params) =>
    http.delete(`/api/cp/event/${eventPassword}/question/messages`, { params })
        .then(onSuccess, onFail);

export const questionSwitchToComment = (eventPassword, questionId) =>
    http.post(`/api/cp/event/${eventPassword}/question/${questionId}/switchTo/comment`)
        .then(onSuccess, onFail);

// Themes
export const getQuestionThemes = eventPassword =>
    http.get(`/api/cp/event/${eventPassword}/chatMessageTheme`)
        .then(onSuccess, onFail);

export const createQuestionTheme = (eventPassword, data) =>
    http.post(`/api/cp/event/${eventPassword}/chatMessageTheme`, data)
        .then(onSuccess, onFail);

export const updateQuestionTheme = (eventPassword, data) =>
    http.put(`/api/cp/event/${eventPassword}/chatMessageTheme/${data.id}`, data)
        .then(onSuccess, onFail);

export const reorderQuestionThemes = (eventPassword, data) =>
    http.post(`/api/cp/event/${eventPassword}/chatMessageTheme/order`, data)
        .then(onSuccess, onFail);

export const deleteQuestionTheme = (eventPassword, themeID) =>
    http.delete(`/api/cp/event/${eventPassword}/chatMessageTheme/${themeID}`)
        .then(onSuccess, onFail);
